module.exports = __webpack_public_path__ + "static/0008-84f0442d38d7290c1b67822018ea0bd5.png";